/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { processFormActions, getFormDefaultState } from '@insticator/insticator-ui'; // iui-utils
import {
    CHANGE_PAYMENT_TYPE, CLEAR_CHECK_ADDRESS, UPDATE_PREFERRED_PAYMENT_TYPE,
    GET_PAYMENT_INFO, FETCHING_PAYMENT_INFO, UPLOAD_FILE, DISCARD_FILE,
    GET_USERS, POPULATE_EDIT_USER_FIELD, ADD_USER, DELETE_USER, UPDATE_USER,SENDING_INVITE,
    UPDATE_USER_STATUS,
    USE_GENERAL_ADDRESS_CHECK, GET_GENERAL_INFO_CHECK, GET_ADS_TXT, VERIFY_ADS_TXT,
    ADS_TXT_FETCHING, RECEIVE_ALL_SITES, SHOW_PUBPORTAL_V2_BUTTON, GET_ACCOUNT_NAME
} from 'state/actions/accountState/account_data';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';

/* ========== ~~~~~~~~~~  ACCOUNT STATUS : REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //


// ============= TRANSPILERS +++++++++++++++ //

const transpileGeneralInformationData = data => ({
    name: { value: !!data.accountName ? data.accountName : '', valid: !!data.accountName ? true : null }, // valid: null / true / false
    address: { value: !!data.streetAddress ? data.streetAddress : '', valid: !!data.streetAddress ? true : null },
    city: { value: !!data.city ? data.city : '', valid: !!data.city ? true : null },
    zip: { value: !!data.zipCode ? data.zipCode : '', valid: !!data.zipCode ? true: null },
    state: { value: !!data.region ? data.region : '', valid: !!data.region ? true : null },
    country: { value: !!data.country ? data.country : '', valid: !!data.country ? true : null }
});

const transpileEditUserData = data => ({
    fname: { value: !!data.firstName ? data.firstName : '', valid: !!data.firstName ? true : null }, // valid: null / true / false
    lname: { value: !!data.lastName ? data.lastName : '', valid: !!data.lastName ? true : null },
    email: { value: !!data.email ? data.email : '', valid: !!data.email ? true : null },
    phone: { value: !!data.phoneNumber ? data.phoneNumber : '', valid: !!data.phoneNumber ? true: null },
    edit_payment: { value: !!data.permissions ? permissionsHelper(data.permissions, `settings.paymentInfo`) : false, valid: true },
    change_permissions: { value: !!data.permissions ? permissionsHelper(data.permissions, `settings.users`) : false, valid: true },
    manage_sites: { value: !!data.permissions ? permissionsHelper(data.permissions, `settings.sites`) : false, valid: true },
    account_information: { value: !!data.permissions ? permissionsHelper(data.permissions, `settings.general`) : false, valid: true },
    adstxt: { value: !!data.permissions ? permissionsHelper(data.permissions, `settings.adsTxt`) : false, valid: true},
    create_embeds: { value: !!data.permissions ? permissionsHelper(data.permissions, `manageEmbeds`) : false, valid: true },
    home_adMetrics: { value: !!data.permissions ? permissionsHelper(data.permissions, `home.adMetrics`) : false, valid: true }
});

const permissionsHelper = (permissions, permission) => permissions.indexOf(permission) >= 0;

const transpileAddUserData = () => ({
    fname: { value: '', valid: null }, // valid: null / true / false
    lname: { value: '', valid: null },
    email: { value: '', valid: null },
    phone: { value: '', valid: null },
    edit_payment: { value: false, valid: true },
    change_permissions: { value: false, valid: true },
    manage_sites: { value: true, valid: true },
    account_information: { value: true, valid: true },
    adstxt: { value: true, valid: true},
    create_embeds: { value: true, valid: true },
    home_adMetrics: { value: true, valid: true }
});

//-=-=-=-=-=-=-=-=-=-=Payment Type Transpilers -=-=-=-=-=-=-=-=-=-=-=-=-=//

const transpileWireTransferData = data => ({
    businessType: { value: !!data.businessType ? data.businessType : '', valid: !!data.businessType ? true : null },
    bankName: { value: !!data.bankName ? data.bankName : '', valid: !!data.bankName ? true : null },
    accountName: { value: !!data.accountName ? data.accountName : '', valid: !!data.accountName ? true : null },
    bankAddress: { value: !!data.bankStreetAddress ? data.bankStreetAddress : '', valid: !!data.bankStreetAddress ? true : null },
    bankCity: { value: !!data.bankCity ? data.bankCity : '', valid: !!data.bankCity ? true : null },
    bankState: { value: !!data.bankRegion ? data.bankRegion : '', valid: !!data.bankRegion ? true : null },
    bankZip: { value: !!data.bankZipCode ? data.bankZipCode : '', valid: !!data.bankZipCode ? true : null },
    bankCountry: { value: !!data.bankCountry ? data.bankCountry : '', valid: !!data.bankCountry ? true : null },
    swift: { value: !!data.swift ? data.swift : '', valid: !!data.swift ? true : null },
    iban: { value: !!data.iban ? data.iban : '', valid: !!data.iban ? true : null },
    //TODO this needs to be tested when getting name and date values back from BE
    form: {
        //w8BENFormLink:
        value:
            {
                form: null,
                name: !!data.businessType ? data.businessType === 'INTERNATIONAL_CORPORATION' ? !!data.w8BENEFormName ? data.w8BENEFormName : '' : !!data.w8BENFormName ? data.w8BENFormName  : '' : '',
                updatedDate: !!data.businessType ? data.businessType === 'INTERNATIONAL_CORPORATION' ? !!data.w8BENEFormUpdateDateTime ? data.w8BENEFormUpdateDateTime : '' : !!data.w8BENFormUpdateDateTime ? data.w8BENFormUpdateDateTime  : '' : '',
                formLink: !!data.businessType ? data.businessType === 'INTERNATIONAL_CORPORATION' ?  data.w8BENEFormLink : data.w8BENFormLink : null,
        },
        valid: !!data.businessType ? data.businessType === 'INTERNATIONAL_CORPORATION' ? !!data.w8BENEFormUpdateDateTime ? true : null : !!data.w8BENFormUpdateDateTime ? true : null : null },

    preferredPayment:{ value: !!data.preferredPayment ? data.preferredPayment: false, valid: true }
});

const transpileCheckData = data => ({
    payTo: { value: !!data.payTo ? data.payTo : !!data.accountName ? data.accountName : '', valid: !!data.payTo ? true : !!data.accountName ? true : null },
    paymentAddress: { value: !!data.paymentStreetAddress ? data.paymentStreetAddress : !!data.streetAddress ? data.streetAddress :'', valid: !!data.paymentStreetAddress ?  true : !!data.streetAddress ? true : null },
    defaultAddress:{ value: !!data.region, valid: true },
    city: { value: !!data.city ? data.city : '', valid: !!data.city ? true : null },
    zip: { value: !!data.zipCode ? data.zipCode : '', valid: !!data.zipCode ? true : null },
    state: { value: !!data.state ? data.state : !!data.region ? data.region : '', valid: !!data.state ? true : !!data.region ? true : null },
    country: { value: !!data.country ? data.country : '', valid: !!data.country ? true : null },
    form:{
        value: {
        name: !!data.w9FormName ? data.w9FormName : '',
        updatedDate: !!data.w9FormUpdateDateTime ? data.w9FormUpdateDateTime : '',
        formLink: !!data.w9FormLink ? data.w9FormLink : null,
        form: null
        },
        valid: !!data.w9FormUpdateDateTime ? true : null },
    preferredPayment:{ value: !!data.preferredPayment ? data.preferredPayment: false, valid: true }
});

const transpilePayPalData = data =>({
    paypalUserName: { value: !!data.paypalUserName ? data.paypalUserName : '', valid: !!data.paypalUserName ? true : null },
    preferredPayment:{ value: !!data.preferredPayment ? data.preferredPayment: false, valid: true }
});

const transpileACHData = data =>({
    bankAccountType: { value: !!data.bankAccountType ? data.bankAccountType : '', valid: !!data.bankAccountType ? true : null },
    bankName: { value: !!data.bankName ? data.bankName : '', valid: !!data.bankName ? true : null },
    accountName: { value: !!data.accountName ? data.accountName : '', valid: !!data.accountName ? true : null },
    routingNumber: { value: !!data.routingCode ? data.routingCode  : '', valid: !!data.routingCode  ? true : null },
    accountNumber: { value: !!data.accountNumber ? data.accountNumber : '', valid: !!data.accountNumber ? true : null },
    form: {
        value:
            {
                form: null,
                name: !!data.w9FormName ? data.w9FormName : '',
                updatedDate: !!data.w9FormUpdateDateTime ? data.w9FormUpdateDateTime : '',
                formLink: !!data.w9FormLink ? data.w9FormLink : null,
        },
        valid: !!data.w9FormUpdateDateTime ? true : null},
    preferredPayment:{ value: !!data.preferredPayment ? data.preferredPayment: false, valid: true }
});


const verifyAdstxt = (data, prevData) => ({
    adsTxtValues: !!data.adsTxtValues ? data.adsTxtValues : prevData.adsTxtValues,
    adsTxtComplete: !!data.adsTxtComplete ? data.adsTxtComplete : prevData.adsTxtComplete,
    containsAdsTxt: data.containsAdsTxt,
    missingElements: !!data.missingElements ? data.missingElements :  prevData.missingElements,
    selectedSite: prevData.selectedSite
});


const getFormTranspiler = formName => {
    switch (formName) {
        case 'generalInformation':
            return transpileGeneralInformationData;
        case 'editUser':
            return transpileEditUserData;
        case 'addUser':
            return transpileAddUserData;
        case 'WIRE':
            return transpileWireTransferData;
        case 'CHECKS':
            return transpileCheckData;
        case 'PAYPAL':
            return transpilePayPalData;
        case 'ACH':
            return transpileACHData;
        default:
            return null;
    }
};



const getDefaultState = () => ({
    //general information
    generalInformation: getFormDefaultState(transpileGeneralInformationData),
    //user management
    users:[],
    editUser: getFormDefaultState(transpileEditUserData),
    addUser: getFormDefaultState(transpileAddUserData),
    resendingInvite: [],
    sendingInvite: false,
    //payment information
    selectedPaymentType: 'NONE',
    preferredPaymentType: null,
    paymentInfo: [],
    savedPaymentTypes: [],
    payoutThreshold: null,
    paymentInfoReceived: false,
    preferredPaymentUpdated: false,
    paymentUUID: null,
    WIRE: getFormDefaultState(transpileWireTransferData),
    CHECKS: getFormDefaultState(transpileCheckData),
    PAYPAL: getFormDefaultState(transpilePayPalData),
    ACH: getFormDefaultState(transpileACHData),
    //sites
    sites:{},
    sitesReceived: false,
    //adstxt
    adsTxt: {
        adsTxtValues: [],
        adsTxtComplete: null,
        containsAdsTxt: null,
        missingElements: [],
        adsTxtFetching: false,
        selectedSite: null
    },
    showPubPortalV2Button: false,
    accountName: null // for heap tracking
});


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const assignedForms = Object.keys(getDefaultState());


const accountData = (state=getDefaultState(), action) => {
    const defaultState = getDefaultState();
    if(action.type.startsWith('FORM_') && assignedForms.includes(action.formName)) {
        let newState = processFormActions(state, action, action.formName, getFormTranspiler(action.formName));
        switch (action.type) {
            case 'FORM_SET_FIELD_VALUE':
                if (action.fieldName === 'businessType') {
                    newState[action.formName].fields.form = defaultState[action.formName].fields.form;
                    newState[action.formName].fields.formName = defaultState[action.formName].fields.formName;
                    newState[action.formName].fields.formUpdateDateTime = defaultState[action.formName].fields.formUpdateDateTime;
                }
                return newState;
            default:
                break;
        }
        return newState;
    }
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RECEIVE_ALL_SITES:
            newState.sites = action.sites;
            newState.sitesReceived = true;
            return newState;
        case GET_PAYMENT_INFO:
            const savedPaymentTypes = [];
            let preferredPaymentType = null;
            newState.paymentInfo = !!action.paymentInfo ? action.paymentInfo : [];
            newState.payoutThreshold = action.payoutThreshold;
            newState.paymentTypes = action.paymentTypes;
            newState.paymentInfoReceived = true;
            // converted map to forEach because we're not actually mapping
            if(action.paymentInfo)action.paymentInfo.forEach(item => {
                if (item.preferredPayment === true) preferredPaymentType = item.paymentType;
                if(item.paymentType !== 'NONE')savedPaymentTypes.push(item.paymentType)
            });
            newState.preferredPaymentType = preferredPaymentType;
            newState.savedPaymentTypes = savedPaymentTypes;
            newState.selectedPaymentType = savedPaymentTypes.includes('PAYPAL') ? 'NONE' : 'PAYPAL';
            return newState;
        case FETCHING_PAYMENT_INFO:
            newState.paymentInfoReceived = false;
            return newState;
        case CHANGE_PAYMENT_TYPE:
            newState.selectedPaymentType = action.paymentType;
            newState.paymentUUID = action.paymentUUID ? action.paymentUUID : null;
            newState.preferredPaymentUpdated = false;
            return newState;
        case UPDATE_PREFERRED_PAYMENT_TYPE:
            newState[action.paymentType].fields.preferredPayment.value = !newState[action.paymentType].fields.preferredPayment.value;
            newState.preferredPaymentUpdated = true;
            return newState;
        case GET_USERS:
            newState.users = action.users;
            return newState;
        case POPULATE_EDIT_USER_FIELD:
            newState.editUser.fields = transpileEditUserData(action.data);
            return newState;
        case ADD_USER:
            newState.users.push(action.user);
            return newState;
        case DELETE_USER:
            newState.users.splice(action.index,1);
            return newState;
        case UPDATE_USER:
            newState.users.splice(action.index,1, action.data);
            return newState;
        case SENDING_INVITE:
            //TODO this will be deleted after QA
            //we are splicing or pushing userUUID to or from the resendingInvite array and checking this array show processing state
            // const currentlySending = newState.resendingInvite.indexOf(action.userUUID);
            // currentlySending < 0 ? newState.resendingInvite.push(action.userUUID) : newState.resendingInvite.splice(currentlySending, 1);
            newState.sendingInvite = action.status;
            return newState;
        case UPDATE_USER_STATUS:
            newState.users = newState.users.map(user => {
                 if(!!user && (user.userUUID === action.userUUID)){
                     user.userStatus = action.status;
                 }
                 return user
            });
            return newState;
        case UPLOAD_FILE:
            newState[action.formName].fields.form.value = JSON.parse(JSON.stringify(defaultState[action.formName].fields.form.value));
            newState[action.formName].fields.form.value.form = action.file;
            newState[action.formName].fields.form.valid = true;
            newState[action.formName].fields.form.value.name = action.file;
            return newState;
        case DISCARD_FILE:
            newState[action.formName].fields.form.value = JSON.parse(JSON.stringify(defaultState[action.formName].fields.form.value));
            newState[action.formName].fields.form.valid = false;
            return newState;
        case USE_GENERAL_ADDRESS_CHECK:
            newState.CHECKS.fields = transpileCheckData(newState.generalInformation.storedData);
            return newState;
        case GET_GENERAL_INFO_CHECK:
            newState.CHECKS.fields = transpileCheckData(action.data);
            newState.generalInformation.fields = transpileGeneralInformationData(action.data);
            newState.generalInformation.storedData = action.data;
            return newState;
        case CLEAR_CHECK_ADDRESS:
            newState.CHECKS.fields = transpileCheckData({});
            return newState;
        case GET_ADS_TXT:
            newState.adsTxt.adsTxtValues = action.adsTxt;
            newState.adsTxt.containsAdsTxt = null;
            newState.adsTxt.missingElements = [];
            newState.adsTxt.selectedSite = action.site;
            return newState;
        case VERIFY_ADS_TXT:
            newState.adsTxt = verifyAdstxt(action.adsTxt, state.adsTxt);
            return newState;
        case ADS_TXT_FETCHING:
            newState.adsTxt.adsTxtFetching = action.bool;
            return newState;
        case CLEAR_ALL_STATES:
            return getDefaultState();
        case SHOW_PUBPORTAL_V2_BUTTON:
            newState.showPubPortalV2Button = action.showPubPortalV2Button;
            return newState;
        case GET_ACCOUNT_NAME:
            newState.accountName = action.accountName;
            return newState;
        default:
            return newState;
    }
};

export default accountData;
